import { Component,  Input } from '@angular/core';
import { publicHelpers } from './../../helpers/public-helpers';
import { WorkerWithProfile } from 'globals/store/workforce.data';
import { TextNoTextComponent } from '../misc/text-no-text.component';
import { CommonModule } from '@angular/common';
import { PhotoComponent } from '../photo';

@Component({
    selector: 'workforce-contact-profile',
    template: `
<div class="performer-box">
  <div class="performer-pics">
    <photo [data]="contact" [size]="120"></photo>
  </div>
  <div class="performer-info">
    <div class="bold-text">{{ contact.firstName }} {{ contact.lastName }}</div>
    <text-no-text [text]="contact.title" [placeholder]="'Job Title'"></text-no-text>
    <text-no-text [text]="contact.company" [placeholder]="'Company'"></text-no-text>
    <div class="spacer"></div>
    <a *ngIf="contact.email" class="secondary_link performer-email" href="mailto:{{contact.email}}">{{contact.email}}</a>

    <text-no-text [text]="contact.phone" ></text-no-text>
  </div>
</div>
<hr />
<div class="greyTitle">ABOUT ME</div>
<text-no-text [text]="contact.aboutMe" [placeholder]="'About workforce contact'"></text-no-text>
<ng-content></ng-content>
  `,
    styleUrls: ['./performerProfile.scss', './managePerformer.dialog.scss'],
    standalone: true,
    imports: [TextNoTextComponent, CommonModule, PhotoComponent]
})
export class WorkforceContactProfileComponent {
  publicHelpers = publicHelpers
  @Input() contact: WorkerWithProfile
}